Customer.Users ||= {}

class Customer.Users.ProfileTagsChartView extends Backbone.View
  template: JST["backbone/templates/customer/users/profile_tags_chart"]

  className: 'main-profile-section main-profile-tags-chart'

  initialize: (@options = {}) ->
    @searchQuery = @options.search_query

  render: ->
    @$el.html(@template())
    @_renderTagsPieChart()
    return this

  _renderTagsPieChart: ->
    @_renderChart(new Monitoring.Views.Charts.CustomOneDimensionChart({
      showBenchmarkOption: false
      searchQuery:  @searchQuery
      fixMissingNames: true
      maxDataPoints: 10 # more tags do not fit in the profile UI
      settings:
        dimension: 'tags'
        type: 'pie'
        avoid_preview: true
      customOptions:
        chart:
          marginTop: 0
          marginBottom: 0
          height: 140
        exporting:
          enabled: false
        legend:
          x: -120
          useHTML: true
          labelFormatter: ->
            return '<div title="'+this.name+'" style="max-width:250px;overflow:hidden;text-overflow: ellipsis;">'+this.name+'</div>'
    }))

  _renderChart: (chart) ->
    chart.appendChart(@$el.find('.chart-container'))
    chart.$el.find('#close_chart').addClass('hidden')